import * as React from "react";
import { FormikErrors } from "formik";

// Types
import InitialValues from "../../types/InitialValues.interface";

// Misc.
import numberToWord from "../../lib/NumberToWords.lib";
import { scrollToFirstError } from "../../lib/Form.lib";

interface QuestionErrorMessage {
  isValid: boolean;
  errors: FormikErrors<InitialValues>;
  submitCount: number;
}

const QuestionErrorMessage: React.FC<QuestionErrorMessage> = (
  props: QuestionErrorMessage
) => {
  const { isValid, errors, submitCount } = props;
  const [firstRun, setFirstRun] = React.useState(true);

  React.useEffect(() => {
    setFirstRun(true);
  }, [submitCount]);

  React.useEffect(() => {
    if (errors && firstRun) {
      scrollToFirstError(errors);
      setFirstRun(false);
    }
  }, [errors, firstRun, setFirstRun]);

  if (!isValid && errors) {
    const errorLength = Object.keys(errors).length;

    const prefix = errorLength === 1 ? "is" : "are";
    const midfix = errorLength === 1 ? "field" : "fields";
    const postfix = errorLength === 1 ? "this" : "these";

    return (
      <div className="mb-1 text-center sm:text-right">
        <p className="text-dw-grey-11 italic text-s">
          {`There ${prefix} ${numberToWord(
            errorLength
          )} unanswered ${midfix}. Please answer ${postfix} to continue.`}
        </p>
      </div>
    );
  }

  return <p>Error!</p>;
};

export default QuestionErrorMessage;
